// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()
import Vue from "vue";
import App from "./App";
import router from "./router";
// 引入vuex
import store from './store/index'
import ElementUI from "element-ui";
import aesRequest from "./assets/js/aesRequest";
import "element-ui/lib/theme-chalk/index.css";

// import axios from "axios";
// axios.defaults.withCredentials = true;

Vue.use(ElementUI);
window.aesRequest = aesRequest;
Vue.prototype.$aesRequest = aesRequest;
// Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

/* eslint-disable no-new */
/*new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});*/
new Vue({
  router,
  store, // 将store挂载到当前实例
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js